import { render } from "./Config.vue?vue&type=template&id=4f80ae32&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"

import "./Config.vue?vue&type=style&index=0&id=4f80ae32&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f80ae32"]])

export default __exports__